import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

export const initialTaskLocalState = {
  task_id: null,
  complaint_id: null,
  complaint_name: null,
  progress_id: null,
  address: null,
  location: null,
  title: null,
  description: null,
  added_by: null,
  assigned_to: null,
  date: new Date().toISOString().split("T")[0], // Default to current date (YYYY-MM-DD)
  start_time: null,
  end_time: null,
  status: "Pending",
  type: "Task General",
  notified_emails: [],
};

export const workDiarySlice = createSlice({
  name: "workDiary",
  initialState: {
    newTaskLocal: initialTaskLocalState,
    workDiaryData: [],
    jobListData: [],
    completeWorkDiaryData: [],
    isCompleteWorkDiaryLoading: false,
    completeWorkDiarySummary: {},
    customerWorkList: [],
    workorList: [],
    workDiaryDetail: null,
    isWorkDiarySuccess: false,
    isWorkDiaryUpdateSuccess: false,
    isBookingStatusUpdated: false,
    workDiaryTypeOptions: [],
    jobOptimiseData: null,
    isJobPrintResponse: false,
    bookingDateCheckResponse: null,
    emailPdfTaskResponse: false,
  },

  reducers: {
    getWorkDiaryAction: (state, { payload }) => {},
    setWorkDiaryAction: (state, { payload }) => {
      console.log("WorkDiaryData", payload);
      state.workDiaryData = payload;
    },

    getWorkDiaryTypeOptionsAction: (state) => {},
    setWorkDiaryTypeOptionsAction: (state, { payload }) => {
      state.workDiaryTypeOptions = payload;
    },

    getJobListAction: (state) => {},
    setJobListAction: (state, { payload }) => {
      state.jobListData = payload;
    },

    getCompleteWorkDiaryAction: (state, { payload }) => {},
    setCompleteWorkDiaryAction: (state, { payload }) => {
      console.log("CompleteWorkDiaryData", payload);
      state.completeWorkDiaryData = payload?.jobList || [];
      state.completeWorkDiarySummary = payload?.summary || {};
      // state.completeWorkDiaryData = payload || [];
    },

    setCompleteWorkDiaryLoading: (state, { payload }) => {
      state.isCompleteWorkDiaryLoading = payload;
    },

    addWorkDairyAction: (state, { payload }) => {},
    setWorkDiaryResponseAction: (state, { payload }) => {
      state.isWorkDiarySuccess = payload;
    },

    updateWorkDairyAction: (state, { payload }) => {},
    setUpdateWorkDiaryResponseAction: (state, { payload }) => {
      state.isWorkDiaryUpdateSuccess = payload;
    },

    getEmailPdfTaskAction: (state, { payload }) => {},
    setEmailPdfTaskResponseAction: (state, { payload }) => {
      state.emailPdfTaskResponse = payload;
    },

    setNewTaskAction: (state, { payload }) => {
      state.newTaskLocal = {
        ...state.newTaskLocal,
        ...payload,
      };
    },

    getJobOptimiseAction: (state, { payload }) => {},
    setJobOptimiseAction: (state, { payload }) => {
      state.jobOptimiseData = payload;
    },

    resetNewTaskAction: (state) => {
      state.newTaskLocal = initialTaskLocalState;
    },

    jobPrintAction: (state, { payload }) => {},
    setJobPrintAction: (state, { payload }) => {
      state.isJobPrintResponse = payload;
    },

    updateWorkDiaryBookingStatusAction: (state, { payload }) => {},
    setUpdateWorkDiaryBookingStatusAction: (state, { payload }) => {
      state.isBookingStatusUpdated = payload;
    },

    checkWorkDiaryBookingDayAction: (state, { payload }) => {},
    setResponseCheckWorkDiaryBookingDayAction: (state, { payload }) => {
      state.bookingDateCheckResponse = payload;
    },

    deleteTaskAction: (state, { payload }) => {},
    setDeleteTaskResponseAction: (state, { payload }) => {
      state.isWorkDiaryUpdateSuccess = payload;
    },
  },
});

const {
  getWorkDiaryAction,
  setWorkDiaryAction,
  getWorkDiaryTypeOptionsAction,
  setWorkDiaryTypeOptionsAction,
  getEmailPdfTaskAction,
  setEmailPdfTaskResponseAction,
  getCompleteWorkDiaryAction,
  setCompleteWorkDiaryAction,
  setCompleteWorkDiaryLoading,
  addWorkDairyAction,
  setWorkDiaryResponseAction,
  updateWorkDairyAction,
  setUpdateWorkDiaryResponseAction,
  setNewTaskAction,
  resetNewTaskAction,
  getJobListAction,
  setJobListAction,
  getJobOptimiseAction,
  setJobOptimiseAction,
  jobPrintAction,
  setJobPrintAction,
  updateWorkDiaryBookingStatusAction,
  setUpdateWorkDiaryBookingStatusAction,
  checkWorkDiaryBookingDayAction,
  setResponseCheckWorkDiaryBookingDayAction,
  deleteTaskAction,
  setDeleteTaskResponseAction,
} = workDiarySlice.actions;

export {
  getWorkDiaryAction,
  setWorkDiaryAction,
  getWorkDiaryTypeOptionsAction,
  setWorkDiaryTypeOptionsAction,
  getEmailPdfTaskAction,
  setEmailPdfTaskResponseAction,
  getCompleteWorkDiaryAction,
  setCompleteWorkDiaryLoading,
  setCompleteWorkDiaryAction,
  addWorkDairyAction,
  setWorkDiaryResponseAction,
  updateWorkDairyAction,
  setUpdateWorkDiaryResponseAction,
  setNewTaskAction,
  resetNewTaskAction,
  getJobListAction,
  setJobListAction,
  getJobOptimiseAction,
  setJobOptimiseAction,
  jobPrintAction,
  setJobPrintAction,
  updateWorkDiaryBookingStatusAction,
  setUpdateWorkDiaryBookingStatusAction,
  checkWorkDiaryBookingDayAction,
  setResponseCheckWorkDiaryBookingDayAction,
  deleteTaskAction,
  setDeleteTaskResponseAction,
};

export default workDiarySlice.reducer;
